import React from "react";
import styled from "styled-components";
import {ButtonInProjectCard} from "./ButtonStyles";

const SendToButton = ({openModal}) => {
    return (
        <Btn onClick={openModal}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#3394F6"/>
                <path
                    d="M16.6667 14.8956C16.0756 14.8956 15.5467 15.1064 15.1422 15.4368L9.59667 12.5201C9.63556 12.3584 9.66667 12.1968 9.66667 12.0281C9.66667 11.8595 9.63556 11.6978 9.59667 11.5362L15.08 8.64761C15.5 8.99901 16.0522 9.21688 16.6667 9.21688C17.9578 9.21688 19 8.27512 19 7.10845C19 5.94178 17.9578 5.00002 16.6667 5.00002C15.3756 5.00002 14.3333 5.94178 14.3333 7.10845C14.3333 7.27712 14.3644 7.43877 14.4033 7.60042L8.92 10.489C8.5 10.1376 7.94778 9.91969 7.33333 9.91969C6.04222 9.91969 5 10.8615 5 12.0281C5 13.1948 6.04222 14.1366 7.33333 14.1366C7.94778 14.1366 8.5 13.9187 8.92 13.5673L14.4578 16.491C14.4189 16.6386 14.3956 16.7932 14.3956 16.9478C14.3956 18.0793 15.4144 19 16.6667 19C17.9189 19 18.9378 18.0793 18.9378 16.9478C18.9378 15.8163 17.9189 14.8956 16.6667 14.8956Z"
                    fill="#FAFAFA"/>
            </svg>

            <p> Partager le pitch projet </p>
        </Btn>
    )
}

const Btn = styled(ButtonInProjectCard)`
`

export default SendToButton;